import React from 'react'
import"./stylesheet/skills.css";
 import { Icon } from '@iconify/react';
 import "./stylesheet/mobilesheet/skillsM.css";
 const card=[
  {icon: <Icon icon="vscode-icons:file-type-html" />,
level:"g",
type:"HTML"},
{icon:<Icon icon="vscode-icons:file-type-css" />,
level:"g",
type:"CSS"},
{icon: <Icon icon="logos:javascript" />,
level:"g",
type:"Javascript"},
{icon: <Icon icon="vscode-icons:file-type-reactjs" />,
level:"g",
type:"Reactjs"},
{icon: <Icon icon="vscode-icons:file-type-python" />,
level:"b",
type:"Python"},
{icon: <Icon icon="logos:c" />,
level:"b",
type:"C lang"},
{icon: <Icon icon="logos:c-plusplus" />,
level:"s",
type:"C++"},
{icon: <Icon icon="logos:git" />,
level:"s",
type:"Git"},
{icon: <Icon icon="cib:notion" />,
level:"b",
type:"Notion"},
{icon: <Icon icon="logos:figma" />,
level:"g",
type:"Figma"},
{icon: <Icon icon="logos:sketch" />,
level:"b",
type:"Sketch"},
{icon: <Icon icon="file-icons:adobe-xd" color="#9747ff" />,
level:"b",
type:"AdobeXD"},
{icon: <Icon icon="vscode-icons:file-type-photoshop" color="#9747ff" />,
level:"b",
type:"Photoshop"},
{icon: <Icon icon="vscode-icons:file-type-php2" color="#9747ff" />,
level:"b",
type:"PHP"},
{icon: <Icon icon="vscode-icons:file-type-node" color="#9747ff" />,
level:"s",
type:"Nodejs"},
{icon:  <Icon icon="file-icons:microsoft-word" color="#5d5fef" />,
level:"s",
type:"Word"},
{icon: <Icon icon="logos:bootstrap" color="#aaa" />,
level:"s",
type:"Bootstrap"},
 



  
]

 export const  Sticker=(props)=>{
  return(<div className="skills-card">
          
  {
    props.data.map((currelem)=>{
      return(
        <div data-content={currelem.type} className={`small small${currelem.level}`} style={{position:"relative"}}>

{currelem.icon}
</div>
      )

    })
  }

</div>)
  
 }

const Skills = () => {
  return (
    <><section className='skills-sec'>
    <div className="main-skills">
<div className="skills">
    <div className="heading">
    <span className="newHeading">Check my Skills!</span>
    <div className="line">
      
    </div>
    <div className="subtext">
      <span className="inside-subtext">
        To Complete Any project. It is important to have Relevent Skills, you can check my skills and make sure  that I am able or not for your Project 
      </span>
    </div>
    </div>
    <div className="card-container">
        <div className="cardbg">

        <div className="label">
<span className="level">
  <span className="text">Beginner</span>
  <span className="sign bronze"></span>
</span>
<span className="level">
  <span className="text">Intermediate</span>
  <span className="sign silver"></span>
</span>
<span className="level">
  <span className="text">Expert</span>
  <span className="sign gold"></span>
</span>

        </div>
        </div>
        <div className="cards">
        <div className="bg">

</div>


          <Sticker data={card}/>

          
          
        </div>
    </div>
</div>
<div className="no-code">
  <h1>Also have Experince in no code website Development 
    
  </h1>
  <div className="no-code-tools">
  <Icon icon="bxl:wix" color="#D9D9D9" />
 <img src="./media/vector.svg" alt="" className='iconify' />
  <Icon icon="fa:wordpress" color="#D9D9D9" />
  </div>

</div>
    </div></section>
    </>
  )
}

export default Skills